export default __webpack_public_path__ + "static/media/birla-mandir.54decb62.jpg";